/** English UI copy. Technique/kata catalog labels stay 漢字 + romaji outside this file. */
export const en = {
  'lang.label': 'Language',
  'lang.en': 'English',
  'lang.ja': '日本語',
  'lang.zhHant': '繁體中文',

  'common.back': '← Back',
  'common.cancel': 'Cancel',
  'common.save': 'Save',
  'common.saving': 'Saving…',
  'common.loading': 'Loading…',
  'common.previous': 'Previous',
  'common.next': 'Next',
  'common.dismiss': 'Dismiss',
  'common.ok': 'OK',
  'common.clear': 'Clear',
  'common.play': 'Play',
  'common.pause': 'Pause',
  'common.start': 'Start',
  'common.end': 'End',
  'common.technique': 'Technique',
  'common.techniques': 'Techniques',
  'common.status': 'Status',
  'common.configured': 'Configured',
  'common.unset': 'Unset',
  'common.opensNewTab': '(opens in a new tab)',

  'library.eyebrow': 'Judo',
  'library.title': '形 KATA',
  'library.subtitle': 'Choose your kata',
  'library.kodokan': 'KODOKAN',
  'library.dataLink': 'Export, import, or reset local data',
  'library.manualLink': 'How to use this app',
  'library.homeScreenTitle': 'Add to Home Screen',
  'library.homeScreenBody':
    'Install this app like a bookmark on your phone or tablet for faster access and a full-screen practice layout.',
  'library.homeScreenInstall': 'Install app',
  'library.homeScreenInstalling': 'Opening install…',
  'library.homeScreenIosStep1': 'Open this site in Safari.',
  'library.homeScreenIosStep2': 'Tap the Share button (square with an arrow).',
  'library.homeScreenIosStep3': 'Choose “Add to Home Screen”, then tap Add.',
  'library.homeScreenAndroidStep1': 'Open this site in Chrome (or Edge).',
  'library.homeScreenAndroidStep2': 'Tap the browser menu (⋮).',
  'library.homeScreenAndroidStep3':
    'Choose “Install app” or “Add to Home screen”, then confirm.',
  'library.waitlistTitle': 'Cloud Sync',
  'library.waitlistBody':
    'Optional paid backup across devices. Free local-first use stays. Learn benefits and planned pricing, then join the waitlist.',
  'library.waitlistLearnMore': 'Learn about Cloud Sync',
  'library.feedbackTitle': 'Feedback',

  'cloudSync.documentTitle': 'Cloud Sync | Judo Kata Practice Tool',
  'cloudSync.backToLibrary': '← Back to kata library',
  'cloudSync.openData': 'Local export / import',
  'cloudSync.openDisclaimer': 'Legal disclaimer',
  'cloudSync.eyebrow': 'Optional paid plan',
  'cloudSync.title': 'Cloud Sync',
  'cloudSync.subtitle':
    'Keep your kata notes, anchors, and preferences across devices. Free local practice stays free.',
  'cloudSync.status': 'Waitlist — not for sale yet. Once enough people sign up, we will build sync.',
  'cloudSync.compareTitle': 'Free vs Cloud Sync',
  'cloudSync.compareLead':
    'Cloud Sync backs up your personal practice data. It does not unlock kata content or YouTube videos.',
  'cloudSync.freeTitle': 'Always free on this device',
  'cloudSync.freeItem1': 'Full kata practice and judging — no account',
  'cloudSync.freeItem2': 'YouTube references, anchors, notes, and favourites in IndexedDB',
  'cloudSync.freeItem3': 'Manual JSON export and import on the Data page',
  'cloudSync.freeItem4': 'Offline-capable app shell after the first visit',
  'cloudSync.paidTitle': 'With Cloud Sync',
  'cloudSync.paidItem1': 'Automatic backup of your personal metadata to the cloud',
  'cloudSync.paidItem2': 'Same setup on phone and laptop after you sign in',
  'cloudSync.paidItem3': 'Recovery if you clear a browser or change devices',
  'cloudSync.paidItem4': 'Preferences synced with your kata data',
  'cloudSync.notIncludedTitle': 'What you are not buying',
  'cloudSync.notIncludedBody':
    'YouTube videos stay free and user-supplied. Cloud Sync does not host video, sell kata media, or add coach/team sharing in v1. Cancelling pauses sync; local data on your devices stays.',
  'cloudSync.howTitle': 'How it will work',
  'cloudSync.howLead': 'Planned flow once the waitlist gate passes and billing launches.',
  'cloudSync.howStep1': 'Sign in with a magic link (email, no password).',
  'cloudSync.howStep2': 'Subscribe to Cloud Sync, then sync runs in the background after local saves.',
  'cloudSync.howStep3':
    'Local data remains the source of truth. If two devices disagree, the latest cloud write wins and a short notice appears.',
  'cloudSync.pricingTitle': 'Planned pricing',
  'cloudSync.pricingLead': 'Same Cloud Sync feature on every paid plan — only the billing period changes.',
  'cloudSync.planMonthlyName': 'Monthly',
  'cloudSync.planMonthlyPrice': 'US$2',
  'cloudSync.planMonthlyPeriod': '/ month',
  'cloudSync.planHalfYearName': 'Half-year',
  'cloudSync.planHalfYearPrice': 'US$11',
  'cloudSync.planHalfYearPeriod': '/ 6 months',
  'cloudSync.planHalfYearNote': 'Training-season commitment',
  'cloudSync.planYearlyName': 'Yearly',
  'cloudSync.planYearlyPrice': 'US$20',
  'cloudSync.planYearlyPeriod': '/ year',
  'cloudSync.planYearlyNote': 'Best value',
  'cloudSync.pricingPhilosophy':
    'Prices are set to cover hosting and login email so the free local app can stay sustainable. You pay for sync of your data — not for YouTube or kata content.',
  'cloudSync.waitlistTitle': 'Join the waitlist',
  'cloudSync.waitlistBody':
    'Email to show interest. Once at least ten people sign up, we will build Cloud Sync. This is not a purchase.',
  'cloudSync.waitlistCta': 'Join the waitlist by email',
  'cloudSync.waitlistSubject': 'Cloud sync waitlist',
  'cloudSync.waitlistEmailBody':
    "Hi,\n\nI'd like to join the Cloud sync waitlist for the Judo Kata app.\n\nThanks!",

  'library.feedbackBody':
    'Ideas, bugs, or questions about this app? Email the developers — we read every message.',
  'library.feedbackCta': 'Send feedback by email',
  'library.feedbackSubject': 'Judo Kata app feedback',
  'library.disclaimer':
    'Personal video URLs and anchors are saved on this device only. Clearing browser data can remove them. Video playback requires an internet connection to YouTube.',

  'practice.changeKata': '← Change kata',
  'practice.editVideoAnchors': 'Edit video',
  'practice.configureVideo': 'Configure video',
  'practice.judgePerformance': 'Practice judging',
  'practice.pastScores': 'Past scores',
  'practice.backToJudging': '← Back to judging',
  'practice.label': 'Practice',
  'practice.selectTechnique': 'Select a technique',
  'practice.selectTechniquePrompt': 'Select a technique to view movement.',
  'practice.category': 'Category',
  'practice.timingNotSet': 'Timing not set',
  'practice.timingNotSetFor':
    'Timing not set for {name}. You can watch the full video, or open the editor to set Start and End.',
  'practice.addVideoTitle': 'Add video',
  'practice.addVideoBody':
    'No YouTube reference is configured for {kata}. Configure an online video to practice technique segments.',
  'practice.addVideoBodyScoring':
    'No YouTube reference yet for {kata}. You can still judge a performance. Add a video when you want technique segments or Watch reference.',
  'practice.addVideo': 'Add video',
  'practice.editAnchors': 'Edit anchors',
  'practice.segment': 'Segment',
  'practice.playbackGroup': 'Segment playback',
  'practice.playSegment': 'Play segment',
  'practice.playing': 'Playing…',
  'practice.replay': 'Replay',
  'practice.playVideo': 'Play video',
  'practice.meta': '{count} techniques · video ID {videoId}',
  'practice.disclaimer':
    'URL and anchors are saved on this device, not the video itself. Playback requires internet.',
  'practice.loadError': 'Could not load local data.',

  'setup.editTitle': 'Edit video',
  'setup.configureTitle': 'Configure video',
  'setup.bannerHint': 'Online YouTube reference',
  'setup.urlLabel': 'YouTube URL',
  'setup.urlHint': 'youtube.com/watch, youtu.be, or embed URLs. No uploads.',
  'setup.titleLabel': 'Reference title (optional)',
  'setup.titleHint': 'Editing only the title keeps existing technique timings.',
  'setup.titlePlaceholder': '{kata} reference',
  'setup.preview': 'Preview',
  'setup.unsaved': 'Unsaved changes',
  'setup.identityWarning':
    'This video ID differs from the saved reference{timings}. Saving will clear existing technique timings so they are not silently reused. Press Confirm replace again to proceed, or edit the title only to keep timings on the current video.',
  'setup.timingsCount': ' ({count} technique timing(s))',
  'setup.confirmReplace': 'Confirm replace',
  'setup.saveReference': 'Save reference',
  'setup.continue': 'Continue',
  'setup.removeVideo': 'Remove video',
  'setup.removing': 'Removing…',
  'setup.removeConfirm':
    'Remove the saved YouTube reference for {kata}? Technique timings for this video will be deleted. The technique catalog is not affected. Notes and favourites are kept.',
  'setup.discardConfirm': 'Discard unsaved changes?',
  'setup.saveFailed': 'Save failed. Local data was not updated.',
  'setup.removeFailed': 'Remove failed. Local data was not updated.',
  'setup.disclaimer':
    'The URL is saved on this device. The video is not downloaded. Playback requires internet.',

  'youtube.error.empty': 'Enter a YouTube URL.',
  'youtube.error.invalid': 'Enter a valid YouTube URL (youtube.com or youtu.be).',
  'youtube.error.unsupportedHost': 'Only YouTube URLs are supported.',
  'youtube.error.missingId': 'Could not find a valid YouTube video ID in that URL.',
  'youtube.error.invalidId': 'Invalid video ID.',
  'youtube.error.html5': 'HTML5 player error.',
  'youtube.error.notFound': 'Video not found or private.',
  'youtube.error.embedDisabled': 'Embedding is disabled for this video.',
  'youtube.error.playback': 'Playback error (code {code}). Try another video.',
  'youtube.error.loadFailed': 'Could not load the YouTube player.',
  'youtube.noVideo': 'No video configured.',
  'youtube.loadingPlayer': 'Loading player…',
  'youtube.loadVideo': 'Load video',
  'youtube.loadVideoHint':
    'Saves mobile data — the stream starts only when you load or play.',
  'youtube.dataSaver.title': 'Save mobile data',
  'youtube.dataSaver.on': 'On',
  'youtube.dataSaver.off': 'Off',
  'youtube.dataSaver.explanation':
    'When on, the app shows a lightweight poster and waits until you Load video, Preview, or Play before starting the YouTube stream. Browsing techniques alone does not download video. When off, the player loads as soon as a reference is shown.',
  'youtube.dataSaver.explanationShort':
    'On: poster first, stream only after Load or Play. Off: load the player immediately.',
  'youtube.dataSaver.note':
    'This does not download or store the video file. Playback still needs internet. Preference is saved on this device and included in JSON export.',
  'youtube.offline':
    'Offline — playback unavailable. Saved URLs and anchors on this device are still available for editing.',
  'youtube.referenceVideo': 'Reference video',

  'anchors.pageTitle': 'Technique anchors',
  'anchors.editorTitle': 'Anchor editor',
  'anchors.needVideo': 'Configure a YouTube reference before editing anchors.',
  'anchors.configureVideo': 'Configure video',
  'anchors.changeRemoveVideo': 'Change / remove video',
  'anchors.heroMeta': '{kata} · {configured}/{total} timed',
  'anchors.allTechniques': 'All techniques',
  'anchors.sideHint': 'Performance order · edit any technique',
  'anchors.durationPending':
    'Duration validation pending — End cannot be verified against video length until the player reports duration. You may still save a valid Start < End range.',
  'anchors.overlapWarning': 'Overlap warning (not blocked): this range overlaps {names}.',
  'anchors.unsaved': 'Unsaved timing changes',
  'anchors.boundTo': 'Bound to video {videoId}',
  'anchors.overview': 'Timing overview',
  'anchors.startBeforeEnd': 'Start must be before End.',
  'anchors.endAfterStart': 'End must be after Start.',
  'anchors.startWithinDuration': 'Start must be within the video duration.',
  'anchors.endWithinDuration': 'End must be within the video duration.',
  'anchors.setBothFirst': 'Set both Start and End first.',
  'anchors.setBothBeforeSave': 'Set both Start and End before saving.',
  'anchors.saved': 'Saved on this device.',
  'anchors.savedPending':
    'Saved on this device. Duration validation pending until the player reports length.',
  'anchors.overlapNote': ' Overlap warning (not blocked): {names}.',
  'anchors.clearConfirm':
    'Clear Start/End for this technique? Saved timing for this technique will be removed.',
  'anchors.cleared': 'Timing cleared on this device.',
  'anchors.clearFailed': 'Clear failed. Local data was not updated.',
  'anchors.discardConfirm': 'Discard unsaved timing changes?',
  'anchors.discardTechniqueConfirm': 'Discard unsaved timing changes for this technique?',
  'anchors.loadError': 'Could not load saved reference.',
  'anchors.saveFailed': 'Save failed. Local data was not updated.',
  'anchors.disclaimer':
    'Anchors, notes, and favourites are saved on this device against this YouTube reference. Replacing the video clears timings (not notes/favourites). The video itself is not downloaded.',

  'controls.captureGroup': 'Capture current time',
  'controls.setStartHere': 'Set start here',
  'controls.setEndHere': 'Set end here',
  'controls.jumpGroup': 'Jump to anchors',
  'controls.jumpStart': 'Jump to start',
  'controls.jumpEnd': 'Jump to end',
  'controls.seekGroup': 'Seek controls',
  'controls.previewSegment': 'Preview segment',

  'timeline.start': 'Start {time}',
  'timeline.end': 'End {time}',
  'timeline.now': 'Now {time}',
  'timeline.duration': 'Duration {time}',
  'timeline.durationPending':
    'Duration pending — validation incomplete until the player reports length',
  'timeline.startHandle': 'Start anchor {time}. Use arrow keys to adjust.',
  'timeline.endHandle': 'End anchor {time}. Use arrow keys to adjust.',
  'timeline.playhead': 'Playhead {time}',

  'personal.title': 'Personal',
  'personal.favourite': 'Favourite',
  'personal.favouriteOn': '★ Favourite',
  'personal.favouriteOff': '☆ Favourite',
  'personal.noteLabel': 'Note for {name}',
  'personal.notePlaceholder': 'Notes (saved on this device)',
  'personal.noteHint':
    'Rich text stays on this device. Media embeds are disabled; content is not executed as HTML.',
  'personal.saveNote': 'Save note',
  'personal.deleteNote': 'Delete note',
  'personal.unsavedNote': 'Unsaved note',
  'personal.loading': 'Loading personal data…',
  'personal.loadError': 'Could not load personal data.',
  'personal.noteSaved': 'Note saved on this device.',
  'personal.noteCleared': 'Note cleared on this device.',
  'personal.noteDeleted': 'Note deleted on this device.',
  'personal.noteSaveFailed': 'Note save failed. Local data was not updated.',
  'personal.noteDeleteConfirm': 'Delete note for {name}?',
  'personal.noteDeleteFailed': 'Could not delete note.',
  'personal.favouriteFailed': 'Could not update favourite.',
  'personal.showNotes': 'Notes',
  'personal.hideNotes': 'Hide notes',
  'personal.fullScreenNote': 'Full-screen note',
  'personal.notesPanel': 'Technique notes',
  'personal.closeNotes': 'Close notes',

  'manual.eyebrow': 'Guide',
  'manual.title': 'How to use',
  'manual.subtitle':
    'Set up your own YouTube references, mark technique anchors, practice kata, and judge performances on this device — no account required.',
  'manual.tocTitle': 'In this guide',
  'manual.backToLibrary': 'Back to kata library',
  'manual.openData': 'Open local data',

  'manual.overviewTitle': 'What this app does',
  'manual.overviewLead':
    'This is a local-first kata practice companion. You bring the YouTube reference; the app keeps timings, notes, favourites, and practice scores in this browser.',
  'manual.overviewStep1':
    'Browse seven Kodokan kata with technique lists in performance order.',
  'manual.overviewStep2':
    'Paste a YouTube URL you choose — nothing ships with a default video catalog.',
  'manual.overviewStep3':
    'Mark Start and End for each technique, practice segment playback, or judge a performance with IJF-style criteria (video still needs internet).',

  'manual.chooseTitle': 'Choose a kata',
  'manual.chooseLead': 'Start from the home library — each card opens that kata’s practice screen.',
  'manual.chooseStep1': 'Open the home screen and pick one of the seven kata cards.',
  'manual.chooseStep2': 'Use Change kata to return to the library whenever you want another form.',
  'manual.chooseStep3': 'When a category applies, select it first, then pick a technique.',

  'manual.videoTitle': 'Add a YouTube reference',
  'manual.videoLead':
    'Practice needs one online YouTube reference per kata. Setup stays separate from everyday viewing.',
  'manual.videoStep1': 'On the kata screen, tap Configure video or Edit video.',
  'manual.videoStep2': 'Paste a youtube.com, youtu.be, or embed URL. An optional title is fine.',
  'manual.videoStep3': 'Preview the player, then Save. The URL is stored on this device only.',
  'manual.videoStep4':
    'To replace or remove a video, open the same setup screen and confirm — replacing a different video ID clears technique timings.',
  'manual.videoNote':
    'Uploads and local video files are not supported. Playback always streams from YouTube.',
  'manual.demoFiguresTitle': 'Example reference video',
  'manual.figDemoAlt':
    'YouTube thumbnail for Perfect Nage No Kata — example reference you can open or paste into Configure video',
  'manual.figDemoCaption': 'Demo — Perfect Nage No Kata (YouTube)',
  'manual.figDemoL1':
    'Tap the image to open https://www.youtube.com/watch?v=URH_OKRN9bs in a new tab.',
  'manual.figDemoL2':
    'Or paste that URL into Configure video to try anchors and segment practice with this reference.',

  'manual.anchorsTitle': 'Mark technique anchors',
  'manual.anchorsLead':
    'Anchors are Start and End times for one technique on your saved reference video.',
  'manual.anchorsStep1': 'Open Edit video, then select a technique from the list.',
  'manual.anchorsStep2':
    'Seek with ±1s / ±5s, Play/Pause, or tap the timeline track to jump to a moment.',
  'manual.anchorsStep3':
    'Use Set start here and Set end here, or type timestamps (mm:ss or hh:mm:ss).',
  'manual.anchorsStep4':
    'Drag the Start and End handles on the timeline — they cannot cross. Preview segment to check the range.',
  'manual.anchorsStep5':
    'Press Save when the range looks right. Other techniques can stay unset until you need them.',
  'manual.anchorsNote':
    'Unsaved edits warn before you leave. Accuracy is best-effort from the YouTube player, not frame-perfect.',

  'manual.figuresTitle': 'Screens from the setup flow',
  'manual.figOpenAlt': 'Kata practice screen showing Configure video and Add video before a reference is set',
  'manual.figOpenCaption': '1 — Open setup from the kata practice screen',
  'manual.figOpenL1': 'Use Configure video in the header.',
  'manual.figOpenL2': 'If no video is set yet, Add video opens the same setup flow.',
  'manual.figOpenL3': 'Techniques stay selectable; you mark timings after a video is saved.',

  'manual.figVideoAlt': 'Configure video screen with YouTube URL field, optional title, and Preview',
  'manual.figVideoCaption': '2 — Paste a YouTube reference',
  'manual.figVideoL1': 'Paste a youtube.com, youtu.be, or embed URL.',
  'manual.figVideoL2': 'Optional title — editing only the title keeps existing timings.',
  'manual.figVideoL3': 'Preview the player, then Save to store the URL on this device.',

  'manual.figEditorAlt':
    'Anchor editor showing technique list, video player, and Start/End timeline controls',
  'manual.figEditorCaption': '3 — Anchor editor layout',
  'manual.figEditorL1': 'Select the technique you are timing from the list.',
  'manual.figEditorL2': 'Watch the reference in the player (internet required).',
  'manual.figEditorL3': 'Drag the Start (S) and End (E) handles on the timeline — they cannot cross.',

  'manual.figMarkAlt':
    'Anchor controls showing timeline, Set start/end, seek buttons, Preview segment, and Save',
  'manual.figMarkCaption': '4 — Mark, preview, and save',
  'manual.figMarkL1': 'Check Start, Now, End, and Duration above the timeline.',
  'manual.figMarkL2': 'Drag S/E handles, use Set start/end here, or type a timestamp.',
  'manual.figMarkL3': 'Fine-seek with ±1s / ±5s, then Preview segment to check the range.',
  'manual.figMarkL4': 'Press Save when the range looks right. Cancel discards unsaved edits.',

  'manual.dataSaverTitle': 'Save mobile data (YouTube)',
  'manual.dataSaverLead':
    'Optional setting that delays the YouTube stream until you choose to load or play — useful on mobile data.',
  'manual.dataSaverStep1':
    'Open Local data from the home footer, or use the Save mobile data control on the practice screen.',
  'manual.dataSaverStep2':
    'Leave it On to show a poster first; the stream starts only after Load video, Preview, or Play.',
  'manual.dataSaverStep3':
    'Turn it Off if you prefer the player to load immediately whenever a reference is shown.',
  'manual.dataSaverNote':
    'A saved URL is still not a downloaded video. The toggle only controls when the online stream begins.',

  'manual.practiceTitle': 'Practice a technique',
  'manual.practiceLead':
    'Everyday practice uses the calm viewer: pick a technique, watch its segment, move on.',
  'manual.practiceStep1': 'Select a technique. If timing is set, the player seeks to Start.',
  'manual.practiceStep2': 'Use Play segment to play from Start and pause near End; Replay returns to Start.',
  'manual.practiceStep3':
    'Unset techniques still open — you can watch the full video or open the editor to add timing.',
  'manual.practiceStep4': 'Previous / Next follow performance order and stop at the ends of the list.',

  'manual.judgeTitle': 'Practice judging',
  'manual.judgeLead':
    'Practice judging lets a partner or coach mark one run with IJF-style criteria and keep a local score history. A YouTube reference is optional for judging.',
  'manual.judgeStep1':
    'On the kata practice screen, tap Practice judging to open the Performances hub.',
  'manual.judgeStep2':
    'Tap Start judging to begin a new run, or Resume if an in-progress draft already exists.',
  'manual.judgeStep3':
    'Work through each scored element. Tap Small (−1), Medium (−3), or Big (−5) on a criterion to apply or clear that deduction.',
  'manual.judgeStep4':
    'Use Forgotten / omitted when a technique is missing — that element scores 0 and the final kata total is halved.',
  'manual.judgeStep5':
    'Optionally add a per-element reviewer comment, or Watch reference to jump back to practice for that technique.',
  'manual.judgeStep6':
    'Tap Save to history when finished. Open past runs from Performances to compare totals and improvement over time.',
  'manual.judgeNote':
    'Practice aid only — not an official competition result. Scores stay on this device and are included when you export local data.',

  'manual.notesTitle': 'Notes and favourites',
  'manual.notesLead': 'Keep personal cues beside each technique without leaving the practice screen.',
  'manual.notesStep1': 'Open Notes on a technique to write or edit text saved on this device.',
  'manual.notesStep2': 'Toggle Favourite to mark techniques you want to find quickly.',
  'manual.notesStep3': 'Notes are plain content for you — they are never run as HTML.',

  'manual.backupTitle': 'Backup and restore',
  'manual.backupLead':
    'Everything personal lives in this browser. Export a JSON file before switching devices or clearing site data.',
  'manual.backupStep1': 'Open Local data from the home footer (or after a storage warning).',
  'manual.backupStep2':
    'Export JSON to download references, timings, notes, favourites, scored performances, and preferences.',
  'manual.backupStep3':
    'Import replaces all personal data after a validated preview — export first if you might need a rollback. Reset clears personal data after typing RESET.',
  'manual.backupNote':
    'Clearing browser or site data can erase local records. Video files are never included in backups.',

  'manual.installTitle': 'Install and offline use',
  'manual.installLead':
    'Add the app to your Home Screen for quicker access. The shell can reopen offline after one successful visit.',
  'manual.installStep1': 'On the home screen, follow Add to Home Screen for your browser.',
  'manual.installStep2':
    'After install (or first load), the UI and saved local data remain available offline.',
  'manual.installStep3':
    'When a new version is ready, reload after saving or cancelling any open edits.',
  'manual.installNote':
    'A saved YouTube URL is not a downloaded video — playback still needs an internet connection.',

  'data.title': 'Local data',
  'data.lead':
    'Export, import, or reset personal data saved in this browser. Video files are never included — only YouTube references, timings, notes, favourites, and preferences.',
  'data.prefsSaveFailed': 'Could not save preference. Try again.',
  'data.onDevice': 'On this device',
  'data.references': '{count} video reference(s)',
  'data.timings': '{count} technique timing(s)',
  'data.notes': '{count} note(s)',
  'data.favourites': '{count} favourite(s)',
  'data.performances': '{count} scored performance(s)',
  'data.loadingCounts': 'Loading counts…',
  'data.storageHint':
    'Clearing site/browser data can also remove these records. Browser storage is not a guaranteed backup.',
  'data.export': 'Export',
  'data.exportBody':
    'Download a schema-versioned JSON backup of personal data. Recommended before import or reset.',
  'data.exportJson': 'Export JSON',
  'data.exportStatus':
    'Exported {references} reference(s), {notes} note(s), {favourites} favourite(s). File saved on this device only.',
  'data.exportFailed': 'Export failed.',
  'data.import': 'Import (replace all)',
  'data.importBody':
    'Validate the full file before writing. A successful import replaces current personal data atomically. Invalid files leave existing data unchanged.',
  'data.exportFirst': 'Export current data first',
  'data.chooseFile': 'Choose JSON file',
  'data.importPreview': 'Import preview',
  'data.importPreviewWarn': 'Confirming will replace all personal data currently on this device.',
  'data.schemaExported': 'Schema v{version} · exported {date}',
  'data.schemaOnly': 'Schema v{version}',
  'data.previewReferences': '{count} reference(s)',
  'data.previewTimings': '{count} timing(s)',
  'data.previewNotes': '{count} note(s)',
  'data.previewFavourites': '{count} favourite(s)',
  'data.previewPerformances': '{count} scored performance(s)',
  'data.preferencesIncluded': 'Preferences: included',
  'data.preferencesEmpty': 'Preferences: empty',
  'data.cancelImport': 'Cancel import',
  'data.confirmImport': 'Confirm replace-all import',
  'data.importConfirm':
    'Replace ALL personal data on this device with the import? Current references, timings, notes, favourites, and preferences will be overwritten. This cannot be undone unless you exported a backup first.',
  'data.importApplied': 'Import applied. Personal data on this device was replaced.',
  'data.importReadFailed': 'Could not read import file.',
  'data.importWriteFailed': 'Import write failed. Prior local data should be unchanged.',
  'data.reset': 'Reset local data',
  'data.resetBody':
    'Permanently delete personal references, timings, notes, favourites, and preferences on this device. The kata catalog is not deleted.',
  'data.resetLabel': 'Type RESET to enable',
  'data.resetButton': 'Reset local personal data',
  'data.resetTypeError': 'Type RESET in the confirmation field to enable local data reset.',
  'data.resetConfirm':
    'Delete all personal video references, timings, notes, favourites, scored performances, and preferences on this device? The technique catalog is not affected. This cannot be undone.',
  'data.resetDone': 'Local personal data cleared on this device.',
  'data.resetFailed': 'Reset failed. Local data was not cleared.',
  'data.loadError': 'Could not read local data.',

  'scoring.hubLabel': 'Practice scores',
  'scoring.hubTitle': 'Performances',
  'scoring.backPractice': '← Practice',
  'scoring.backPerformances': '← Performances',
  'scoring.newPerformance': 'Start judging',
  'scoring.resumeDraft': 'Resume in-progress run',
  'scoring.latest': 'Latest {score} / {max}',
  'scoring.deltaUp': '+{delta} vs previous',
  'scoring.deltaDown': '{delta} vs previous',
  'scoring.improvement': 'Improvement',
  'scoring.improvementEmpty': 'Save a few runs to history to see totals over time.',
  'scoring.past': 'Past performances',
  'scoring.empty': 'No scored performances yet. Start a practice judging run.',
  'scoring.statusComplete': 'Saved',
  'scoring.statusDraft': 'In progress',
  'scoring.resume': 'Resume',
  'scoring.open': 'Open',
  'scoring.delete': 'Delete',
  'scoring.deleteConfirm': 'Delete this performance from this device?',
  'scoring.judgeLabel': 'Judging',
  'scoring.scoreBar': '{total} / {max}',
  'scoring.reviewed': '{reviewed} / {total} reviewed',
  'scoring.halfPenaltyOn': 'Half penalty ON',
  'scoring.halfPenaltyOff': 'Half penalty off',
  'scoring.complete': 'Save to history',
  'scoring.elements': 'Elements',
  'scoring.mistakesOnElement': 'Mistakes on this element — tap a severity to apply',
  'scoring.suggested': 'suggested {kind}',
  'scoring.severitySmall': 'Small',
  'scoring.severityMedium': 'Medium',
  'scoring.severityBig': 'Big',
  'scoring.forgotten': 'Forgotten / omitted',
  'scoring.forgottenHint': 'Sets this element to 0 and halves the final kata total.',
  'scoring.elementComment': 'Reviewer comment (optional)',
  'scoring.elementCommentPlaceholder': 'Notes for this technique / element…',
  'scoring.elementCommentHint': 'Saved with this element only — not for the whole performance.',
  'scoring.applied': 'Applied deductions → {points} / 10',
  'scoring.prevElement': 'Previous element',
  'scoring.nextElement': 'Next element',
  'scoring.watchReference': 'Watch reference',
  'scoring.completeTitle': 'Save this performance',
  'scoring.scoredBy': 'Scored by (optional)',
  'scoring.note': 'Note (optional)',
  'scoring.unreviewedWarn':
    '{count} element(s) were never reviewed. Unreviewed elements still count as 10. Save to history anyway?',
  'scoring.saveComplete': 'Save to history',
  'scoring.readOnly': 'Saved · read-only',
  'scoring.duplicateNew': 'Start fresh run',
  'scoring.unsupported': 'Practice scoring is not available for this kata yet.',
  'scoring.loadError': 'Could not load scoring data.',
  'scoring.disclaimer':
    'Practice aid using IJF-style criteria. Not an official competition result. © IJF Kata Commission criteria text.',
  'scoring.criteriaSourceLabel': 'Performance judging guideline:',
  'scoring.criteriaNotifyCta': 'Notify about a newer version',
  'scoring.criteriaNotifySubject': 'Newer IJF kata evaluation guideline',
  'scoring.criteriaNotifyBody':
    'Hi,\n\nThe practice judging guideline in the app currently uses:\n{title}\n{url}\n\nA newer version has been published.\n\nThanks!',
  'scoring.translationDisclaimer':
    'Translated marking-scheme text is unofficial and may be inaccurate. Follow the English criteria when scoring.',
  'scoring.showEnglishCriteria': 'Show English',
  'scoring.showTranslatedCriteria': 'Show translation',
  'scoring.kindSmall': 'Small',
  'scoring.kindMedium': 'Medium',
  'scoring.kindSmallMedium': 'Small/Medium',
  'scoring.kindBig': 'Big',
  'scoring.kindForgotten': 'Forgotten',

  'pwa.skipLink': 'Skip to main content',
  'pwa.offline':
    "You're offline. The app shell and saved local data still work. YouTube playback requires internet — a saved URL is not a downloaded video.",
  'pwa.offlineReady':
    'App ready for offline use. Personal data remains in this browser; video playback still needs a connection.',
  'pwa.persistDenied':
    'Browser may clear local data under storage pressure. Export a backup from Local data when needed.',
  'pwa.updateRegion': 'App update available',
  'pwa.updateReady': 'A new version is ready.',
  'pwa.reload': 'Reload when ready',
  'pwa.notNow': 'Not now',
  'pwa.updateBlocked': 'Save or cancel your current edits before reloading for an app update.',
} as const

export type MessageKey = keyof typeof en
export type Messages = Record<MessageKey, string>
